module.exports = __webpack_public_path__ + "img/voltaje_b_red.132d9bf2.svg";